import Link from 'next/link'

export default function NotFound() {
    return (
        <div className="bg-white">
            {/* <h1>Error</h1> */}
            <>
                {/* preloader */}
                {/* <div className="preloader">
              <div className="loader-ripple">
                <div />
                <div />
              </div>
            </div> */}
                {/* preloader end */}
                {/* header area */}
                {/* header area end */}
                {/* popup search */}
                <div className="search-popup">
                    <button className="close-search">
                        <span className="far fa-times" />
                    </button>
                    <form action="#">
                        <div className="form-group">
                            <input
                                type="search"
                                name="search-field"
                                className="form-control"
                                placeholder="Search Here..."
                                required={true}
                            />
                            <button type="submit">
                                <i className="far fa-search" />
                            </button>
                        </div>
                    </form>
                </div>
                {/* popup search end */}
                {/* sidebar-popup */}
                <div
                    className="sidebar-popup offcanvas offcanvas-end"
                    tabIndex={-1}
                    id="sidebarPopup"
                >
                    <div className="offcanvas-header">
                        <a href="index-2.html" className="sidebar-popup-logo">
                            <img src="assets/img/logo/logo.png" alt="" />
                        </a>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        >
                            <i className="far fa-xmark" />
                        </button>
                    </div>
                    <div className="sidebar-popup-wrap offcanvas-body">
                        <div className="sidebar-popup-content">
                            <div className="sidebar-popup-about">
                                <h4>About Us</h4>
                                <p>
                                    There are many variations of passages available sure there majority
                                    have suffered alteration in some form by inject humour or randomised
                                    words which don't look even slightly believable.
                                </p>
                            </div>
                            <div className="sidebar-popup-contact">
                                <h4>Contact Info</h4>
                                <ul>
                                    <li>
                                        <div className="icon">
                                            <i className="far fa-envelope" />
                                        </div>
                                        <div className="content">
                                            <h6>Email</h6>
                                            <a href="https://live.themewild.com/cdn-cgi/l/email-protection#8ce5e2eae3cce9f4ede1fce0e9a2efe3e1">
                                                <span
                                                    className="__cf_email__"
                                                    data-cfemail="3b52555d547b5e435a564b575e15585456"
                                                >
                                                    email
                                                </span>
                                            </a>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <i className="far fa-phone" />
                                        </div>
                                        <div className="content">
                                            <h6>Phone</h6>
                                            <a href="tel:"></a>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <i className="far fa-location-dot" />
                                        </div>
                                        <div className="content">
                                            <h6>Address</h6>
                                            <a href="#"></a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="sidebar-popup-social">
                                <h4>Follow Us</h4>
                                <a href="#">
                                    <i className="fab fa-facebook" />
                                </a>
                                <a href="#">
                                    <i className="fab fa-x-twitter" />
                                </a>
                                <a href="#">
                                    <i className="fab fa-instagram" />
                                </a>
                                <a href="#">
                                    <i className="fab fa-linkedin" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/* sidebar-popup end */}
                <main className="main">
                    {/* breadcrumb */}
                    <div
                        className="site-breadcrumb"
                        style={{ background: "url(../../assets/img/breadcrumb/01.jpg)" }}
                    >
                        <div className="container">
                            <h2 className="breadcrumb-title">404 Error</h2>
                            <ul className="breadcrumb-menu">
                                <li>
                                    <a href="index-2.html">Home</a>
                                </li>
                                <li className="active">404 Error</li>
                            </ul>
                        </div>
                    </div>
                    {/* breadcrumb end */}
                    {/* error area */}
                    <div className="error-area py-120">
                        <div className="container">
                            <div className="col-md-8 mx-auto">
                                <div className="error-wrap">
                                    <div className="error-img">
                                        <img src="assets/img/error/404.png" alt="" />
                                    </div>
                                    <h2>Opos... Page Not Found!</h2>
                                    <p>
                                        The page you looking for not found may be it not exist or removed.
                                    </p>
                                    <Link href="/" className="theme-btn">
                                        Go Back Home <i className="far fa-home" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* error area end */}
                </main>
                {/* footer area */}

                {/* footer area end */}
                {/* scroll-top */}

                {/* scroll-top end */}
                {/* js */}
            </>

        </div>
    )
}